import * as Yup from 'yup';
import { DictionaryProcessingPurposeAutocomplete } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryProcessingPurposeAutocomplete>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
